export type AssignedBookingLabelsType = string[];

type updateLabelsDataType = {
  id: string;
  value: boolean;
  assignedLabels?: AssignedBookingLabelsType;
};
export const updateLabelsData = ({
  id,
  value,
  assignedLabels
}: updateLabelsDataType): AssignedBookingLabelsType => {
  let assignedLabelsReturn = [...(assignedLabels ?? [])];

  if (value) {
    assignedLabelsReturn?.push(id);
  } else {
    assignedLabelsReturn = (assignedLabels ?? []).filter(
      (label) => label !== id
    );
  }

  return assignedLabelsReturn;
};
